<div class="image-meta">
  <div class="row">
    <app-text [formGroup]="model().meta.formGroup" [model]="$safeNavigationMigration(model()?.type?.data?.pattern)" [meta]="metaPattern"></app-text>
  </div>
</div>
